import styled from 'styled-components';

export const StyledUsercentricsTrigger = styled.button`
  position: fixed;
  bottom: 0px;
  left: 0px;
  background: ${({ theme }) => theme.palette.black[700]};
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  path {
    fill: ${({ theme }) => theme.palette.white};
  }
`;
